import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { PartyPopper, ArrowRight } from "lucide-react";
import { motion } from "framer-motion";

export default function OccasionsIndex() {
  const navigate = useNavigate();
  const { data: categories = [] } = useQuery({
    queryKey: ["categories"],
    queryFn: async () => (await api.get("/categories")).data,
  });

  return (
    <div className="px-4 md:px-8 py-6">
      <div className="flex items-center gap-3 mb-1">
        <div className="h-11 w-11 rounded-xl bg-primary/10 grid place-items-center">
          <PartyPopper className="h-5 w-5 text-primary" />
        </div>
        <div>
          <p className="overline text-primary">Build your own event</p>
          <h1 className="font-display font-extrabold text-3xl tracking-tight">By Occasion</h1>
        </div>
      </div>
      <p className="text-muted-foreground text-sm mb-6">
        Pick an occasion, then choose each service — decoration, catering, DJ, shamiyana & more — from
        multiple vendors and prices. Mix and match to build your perfect event.
      </p>

      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
        {categories.map((c, i) => (
          <motion.button
            key={c.id}
            data-testid={`occasion-${c.slug}`}
            onClick={() => navigate(`/occasions/${c.slug}`)}
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.05 }}
            className="relative h-52 rounded-2xl overflow-hidden group text-left"
          >
            <img src={c.image} alt={c.name} className="absolute inset-0 h-full w-full object-cover group-hover:scale-105 transition-transform duration-500" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/25 to-transparent" />
            <div className="absolute bottom-4 left-4 right-4 text-white">
              <p className="font-display font-extrabold text-2xl leading-none">{c.name}</p>
              <p className="text-white/75 text-xs mt-1">{c.tagline}</p>
              <span className="inline-flex items-center gap-1 text-xs font-semibold mt-2 text-secondary">
                Build event <ArrowRight className="h-3.5 w-3.5" />
              </span>
            </div>
          </motion.button>
        ))}
      </div>
    </div>
  );
}
